import { all, fork, put, takeEvery, call } from "redux-saga/effects";
import { SagaIterator } from "@redux-saga/core";

// actions
import { subApiResponseSuccess, subApiResponseError, getSub } from "./actions";

// constants
import { SubActionTypes } from "./constants";
import { deleteSubApi, getSubApi } from "../../helpers/api/subscriptions";

interface categoryData {
  payload: {
    id: number;
  };
  type: string;
}

function* getSubb(): SagaIterator {
  try {
    const response = yield call(getSubApi);

    const categoryData = response?.data;

    yield put(subApiResponseSuccess(SubActionTypes.GET_SUB, categoryData));
  } catch (error: any) {
    yield put(subApiResponseError(SubActionTypes.GET_SUB, error));
  }
}

function* deleteSub({ payload: { id } }: categoryData): SagaIterator {
  try {
    const response = yield call(deleteSubApi, id);
    const categoryData = response.data.message;
    // NOTE - You can change this according to response format from your api

    yield put(subApiResponseSuccess(SubActionTypes.DELETE_SUB, categoryData));
    yield put(getSub());
  } catch (error: any) {
    yield put(subApiResponseError(SubActionTypes.DELETE_SUB, error));
  }
}

export function* watchGetSub() {
  yield takeEvery(SubActionTypes.GET_SUB, getSubb);
}

export function* watchDeleteSub() {
  yield takeEvery(SubActionTypes.DELETE_SUB, deleteSub);
}

function* subSaga() {
  yield all([fork(watchDeleteSub), fork(watchGetSub)]);
}

export default subSaga;
